<div class="p-6 max-w-3xl mx-auto">

  <div class="mb-5">
    <h1 class="text-xl font-semibold text-gray-900 dark:text-white">Probar Acciones</h1>
    <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">
      Prueba acciones de comunicación RF-06 sin necesidad de ejecutar un workflow completo.
    </p>
  </div>

  @if (error) {
    <div class="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-lg flex justify-between text-sm">
      <span>{{ error }}</span><button (click)="error = ''">&times;</button>
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">

    <!-- Formulario -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Configuración</h2>

      <div class="space-y-3">
        <!-- Tipo de acción -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de acción *</label>
          <select [(ngModel)]="actionType" (ngModelChange)="onActionTypeChange()"
                  class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            @for (opt of actionTypeOptions; track opt.value) {
              <option [value]="opt.value" [disabled]="!opt.enabled">
                {{ opt.label }} {{ !opt.enabled ? '(no disponible)' : '' }}
              </option>
            }
          </select>
        </div>

        <!-- Tipo de objeto -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Tipo de objeto</label>
          <select [(ngModel)]="objectType"
                  class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
            @for (ot of objectTypeOptions; track ot.value) {
              <option [value]="ot.value">{{ ot.label }}</option>
            }
          </select>
        </div>

        <!-- SEND_INTERNAL_NOTIFICATION -->
        @if (isInternalNotif) {
          <div class="grid grid-cols-2 gap-2">
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Destinatario</label>
              <select [(ngModel)]="notifRecipientType"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
                @for (r of recipientTypeOptions; track r.value) { <option [value]="r.value">{{ r.label }}</option> }
              </select>
            </div>
            <div>
              <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Canal</label>
              <select [(ngModel)]="notifChannel"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500">
                @for (c of channelOptions; track c.value) { <option [value]="c.value">{{ c.label }}</option> }
              </select>
            </div>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Asunto</label>
            <input type="text" [(ngModel)]="notifSubject"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Mensaje</label>
            <textarea [(ngModel)]="notifMessage" rows="3"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
            <p class="text-[11px] text-gray-400 mt-0.5">Puedes usar tokens de contacto (p. ej. el nombre) que se reemplazan al enviar.</p>
          </div>
        }

        <!-- SEND_MARKETING_EMAIL -->
        @if (isMarketingEmail) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Plantilla de email (opcional)</label>
            @if (emailTemplatesAccessible) {
              <app-entity-select
                [value]="emailTemplateId"
                [displayText]="emailTemplateName"
                (valueChange)="emailTemplateId = $event"
                (selected)="onEmailTemplateSelected($event)"
                [searchFn]="emailTemplateSearch" [labelFn]="emailTemplateLabel" [sublabelFn]="emailTemplateSublabel"
                [allowClear]="true"
                placeholder="Buscar plantilla por asunto/propósito…"></app-entity-select>
            } @else {
              <input type="number" [(ngModel)]="emailTemplateId" placeholder="ID de plantilla"
                     class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
              <p class="text-[11px] text-gray-400 mt-1">Sin acceso al catálogo de plantillas; ingresa el ID.</p>
            }
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Asunto</label>
            <input type="text" [(ngModel)]="emailSubject"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="respectSubscription" class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Respetar suscripción de marketing</span>
          </label>
        }

        <!-- SEND_ONE_TO_ONE_EMAIL -->
        @if (isOneToOneEmail) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Asunto</label>
            <input type="text" [(ngModel)]="otoeSubject"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Cuerpo</label>
            <textarea [(ngModel)]="otoeBody" rows="3"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Correos extra en «Para» (opcional)</label>
            <input type="text" [(ngModel)]="otoeExtraEmailsRaw" placeholder="externo@dominio.com, otro@dominio.com"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
            <p class="text-[11px] text-gray-400 mt-0.5">Se suman al contacto del registro. Separa varios con comas.</p>
          </div>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" [(ngModel)]="otoeFromOwner" class="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"/>
            <span class="text-xs text-gray-700 dark:text-gray-300">Enviar desde el responsable</span>
          </label>
        }

        <!-- SEND_TEAMS_NOTIFICATION -->
        @if (isTeamsNotif) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Canal de Teams</label>
            <input type="text" [(ngModel)]="teamsChannelId" placeholder="Ej: general"
                   class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
          </div>
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Mensaje</label>
            <textarea [(ngModel)]="teamsMessage" rows="3"
                      class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none"></textarea>
          </div>
        }

        <!-- Contexto de prueba -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Nombre de contacto (para probar tokens)</label>
          <input type="text" [(ngModel)]="demoContactName" placeholder="Ej: Juan"
                 class="w-full px-3 py-2 text-sm border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-500"/>
        </div>

        <button (click)="test()" [disabled]="loading"
                class="w-full py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-colors inline-flex items-center justify-center gap-2">
          @if (loading) {
            <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
            </svg>
            Ejecutando...
          } @else {
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            Ejecutar acción
          }
        </button>
      </div>
    </div>

    <!-- Resultado -->
    <div class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5">
      <h2 class="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-4">Resultado</h2>

      @if (!result && !loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-300 dark:text-gray-600">
          <svg class="w-10 h-10 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z"/>
          </svg>
          <p class="text-sm">Ejecuta una acción para ver el resultado</p>
        </div>
      }

      @if (loading) {
        <div class="flex flex-col items-center justify-center py-10 text-gray-400">
          <svg class="animate-spin w-8 h-8 mb-3" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"/>
          </svg>
          <p class="text-sm">Ejecutando acción...</p>
        </div>
      }

      @if (result && !loading) {
        <!-- Status badge -->
        <div class="flex items-center gap-3 mb-4 p-3 rounded-lg"
             [ngClass]="result.status === 'SUCCESS' ? 'bg-green-50 dark:bg-green-900/20' : result.status === 'SKIPPED' ? 'bg-gray-50 dark:bg-gray-700/40' : 'bg-red-50 dark:bg-red-900/20'">
          <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                [ngClass]="getStatusClass(result.status)">
            {{ statusLabel(result.status) }}
          </span>
          <p class="text-sm text-gray-700 dark:text-gray-300">{{ result.message ?? '' }}</p>
        </div>

        <!-- Detalles -->
        <dl class="space-y-2 text-sm mb-4">
          @if (result.actionType) {
            <div class="flex justify-between">
              <dt class="text-xs text-gray-500">Tipo de acción</dt>
              <dd class="text-xs font-medium text-gray-900 dark:text-white">{{ actionTypeLabel(result.actionType) }}</dd>
            </div>
          }
        </dl>

        <!-- Destinatarios resueltos (acciones de email) -->
        @if (resultRecipients) {
          <div class="mb-3">
            <app-workflow-recipient-list [value]="resultRecipients" />
          </div>
        }

        <!-- Warnings -->
        @if (result.warnings?.length) {
          <div class="p-2 bg-amber-50 border border-amber-200 rounded text-xs text-amber-700 mb-3">
            @for (w of result.warnings; track w) { <p>⚠ {{ w }}</p> }
          </div>
        }

        <!-- Output JSON -->
        @if (result.output && (result.output | json) !== '{}') {
          <div>
            <p class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-1">Resultado (JSON)</p>
            <pre class="text-xs font-mono bg-gray-50 dark:bg-gray-700/40 p-3 rounded-lg overflow-x-auto text-gray-800 dark:text-gray-200 whitespace-pre-wrap">{{ resultOutputJson }}</pre>
          </div>
        }
      }
    </div>
  </div>

  <!-- Info note -->
  <div class="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg text-xs text-blue-700 dark:text-blue-300">
    <p class="font-semibold mb-1">Acciones habilitadas en RF-06:</p>
    <div class="flex flex-wrap gap-1.5 mt-1">
      @for (opt of actionTypeOptions; track opt.value) {
        @if (opt.enabled) {
          <span class="px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/30 rounded text-[10px]">{{ opt.label }}</span>
        }
      }
    </div>
    <p class="mt-2 text-blue-500">Slack, SMS y WhatsApp necesitan su integración configurada; hasta entonces la acción se registra como "Omitido".</p>
  </div>
</div>
